
import { defineComponent } from 'vue'
import copy from 'copy-to-clipboard'
import { useStore } from 'vuex'

export default defineComponent({
  props: {
    icon: { type: Object, required: true }
  },
  setup (props) {
    const store = useStore()

    function handleClick () {
      copy(props.icon.name)

      store.dispatch('toast', {
        title: props.icon.name,
        text: 'copied to clipboard'
      })
    }

    return {
      handleClick
    }
  }
})
